/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';

import { Button, Modal } from '@mairistem/composants';

interface AssistantModalErrorStepFinProps {
  /** Callback appelé lors de la validation de la modal */
  onValidate: () => void;
  /** Callback appelé lors de la fermeture de la modal */
  onClose: () => void;
}

const AssistantModalErrorStepFin = (props: AssistantModalErrorStepFinProps) => {
  const { onValidate, onClose } = props;

  return (
    <Modal
      open
      closeIcon
      onClose={onClose}
      data-testid="assistant-modal-error-step-fin"
    >
      <Modal.Header>Erreurs de validation</Modal.Header>
      <Modal.Content>
        <div>
          <p>
            Il y a des erreurs de saisies sur une ou plusieurs étapes. Veuillez
            corriger les erreurs afin de procéder à l&apos;enregistrement
            <br />
            <br />
            En cliquant sur valider, vous serez redirigé vers la première étape
            en erreur.
          </p>
        </div>
      </Modal.Content>
      <Modal.Actions>
        <Button
          data-testid="assistant-modal-error-step-fin-annuler"
          content="Annuler"
          icon="cancel"
          size="tiny"
          basic
          onClick={onClose}
        />
        <Button
          data-testid="assistant-modal-error-step-fin-valider"
          content="Valider"
          icon="check"
          positive
          onClick={onValidate}
        />
      </Modal.Actions>
    </Modal>
  );
};

export default AssistantModalErrorStepFin;
